import React from 'react';
import YandexAuth from '../../components/Auth/YandexAuth';
import './Login.css';

const Login: React.FC = () => {
  const handleTelegramLogin = () => {
    // TODO: Implement Telegram Web App login
    // For Telegram Web App, use window.Telegram.WebApp
    alert('Telegram авторизация будет реализована в следующей версии');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Vizify</h1>
          <p>AI-Powered Trading Platform</p>
        </div>

        <div className="login-content">
          <h2>Добро пожаловать</h2>
          <p className="subtitle">Выберите способ входа</p>

          <div className="auth-buttons">
            {/* Telegram Auth Button */}
            <button
              onClick={handleTelegramLogin}
              className="telegram-login-button"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
              </svg>
              Войти через Telegram
            </button>

            {/* Yandex Auth Button */}
            <YandexAuth />
          </div>

          <div className="login-footer">
            <p>Продолжая, вы соглашаетесь с</p>
            <div className="links">
              <a href="/terms">Условиями использования</a>
              <span>и</span>
              <a href="/privacy">Политикой конфиденциальности</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
